export enum RestCountriesApiPath {
  All = "all",
}
